import { Table, TableContainer, Thead, Tr, Tbody, Text, Flex, Tooltip, Icon, Button } from '@chakra-ui/react'
import * as S from './styles'
import { HeadingPages } from '../../../components/HeadingPages'
import React, { useState, useEffect } from 'react'
import { baseURL } from '../../../services/api'
import { format } from 'date-fns'
import { firstLetterUpperCaseAndRestLowerCase } from '../../../utils/capitalFirstLetter'
import { Filtro } from './components/Filtro'
import { FaArrowAltCircleDown, FaFileExcel } from 'react-icons/fa'
import { HistoricoTroca } from './components/HistoricoTroca'
import { useExcelGenerator } from '../../../hooks/useExcelGenerator'

export function AcompanhamentoTrocas() {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [fornecedores, setFornecedores] = useState([])

  const { generateExcel, loading: excelLoading } = useExcelGenerator()

  async function getAcompanhamentoTrocas(filter) {
    try {
      setLoading(true)
      const response = await baseURL.get('/pedido/listar-info-acompanhamento-trocas')

      const fornecedores = response?.data
        .map((item) => {
          return {
            value: item.nome_fornecedor,
            label: item.nome_fornecedor,
          }
        })
        .filter((item, index, self) => self.findIndex((t) => t.value === item.value) === index)

      setFornecedores(fornecedores)

      const formattedData = response.data.map((item) => {
        return {
          ...item,
          recebimento_troca: item.recebimento_troca ? format(new Date(item.recebimento_troca), 'dd/MM/yyyy HH:mm') : 'Sem data',
        }
      })

      const dataOrder = formattedData?.sort((a, b) => (a.dt_termino_prod > b.dt_termino_prod ? 1 : b.dt_termino_prod > a.dt_termino_prod ? -1 : 0))

      if (filter.nPedido) {
        const filterPed = dataOrder.filter((item) => item.numero_pedido === filter.nPedido)
        setData(filterPed)
        return
      }

      if (filter.dataDe && filter.dataAte) {
        const filterDate = dataOrder.filter(
          (item) => item.troca_solicita.substring(0, 10) >= filter.dataDe && item.troca_solicita.substring(0, 10) <= filter.dataAte
        )
        setData(filterDate)
        return
      }

      if (filter.pendente) {
        const filterStatus = dataOrder.filter((item) => item.pendente === filter.pendente)
        setData(filterStatus)
        return
      }

      if (filter.fornecedor) {
        const filterForn = dataOrder.filter((item) => item.nome_fornecedor === filter.fornecedor)
        setData(filterForn)
        return
      }

      setData(dataOrder)

      console.log('resposta', response)
    } catch (error) {
      console.log('error', error)
    } finally {
      setLoading(false)
    }
  }

  const [ordered, setOrdered] = useState(false)
  const [orderedByTroca, setOrderedByTroca] = useState(false)

  function handleOrderBy(orderBy) {
    //create toggle sort order
    setOrdered(!ordered)
    //sort data
    const dataOrder = data.sort((a, b) => (ordered ? (a[orderBy] > b[orderBy] ? 1 : -1) : b[orderBy] > a[orderBy] ? 1 : -1))

    setData(dataOrder)
  }

  function handleOrderByTrocaA(trocaDias) {
    //create toggle sort order
    setOrderedByTroca(!orderedByTroca)
    //sort data
    const dataOrder = data.sort((a, b) => (orderedByTroca ? (a[trocaDias] > b[trocaDias] ? 1 : -1) : b[trocaDias] > a[trocaDias] ? 1 : -1))

    setData(dataOrder)
  }

  async function handleGenerateExcel() {
    const header = [
      'Compra',
      'Troca solicitada',
      'Qtd. troca',
      'Troca compras',
      'Ped',
      'Prod',
      'Fornecedor',
      'Descrição',
      'Cor',
      'Gravação',
      'Qtd Ped.',
      'Solicição de Troca',
      'Termino da prod',
      'Troca A',
    ]

    const dataItems = data.map((item) => {
      return {
        Compra: item.data_compra ? format(new Date(item.data_compra), 'dd/MM/yyyy') : '',
        'Troca solicitada': item.troca_solicita ? format(new Date(item.troca_solicita), 'dd/MM/yyyy HH:mm') : '',
        'Qtd. troca': item.quantidade_troca,
        'Troca compras': item.troca_compras ? format(new Date(item.troca_compras), 'dd/MM/yyyy HH:mm') : '',
        Ped: item.numero_pedido,
        Prod: item.codigo_produto,
        Fornecedor: item.nome_fornecedor,
        Descrição: item.descricao_produto,
        Cor: item.cor,
        Gravação: item.impressao,
        'Qtd Ped.': item.quantidade_pedido,
        'Solicição de Troca': item.trocas_solicitadas,
        'Termino da prod': item.dt_termino_prod ? format(new Date(item.dt_termino_prod), 'dd/MM/yyyy') : '',
        'Troca A': item.prazo_entrega + ' dias',
      }
    })

    await generateExcel(header, dataItems, 'AcompanhamentoTrocas')
  }

  const list = data?.map((item, index) => {
    return (
      <Tr key={index}>
        <S.Td>
          <Flex justifyContent="center" w="full">
            <Text textAlign="center" whiteSpace="pre-line" maxW="80px">
              <Text>
                {item.data_compra ? format(new Date(item.data_compra), 'dd/MM/yyyy') : ''}
                <Text>{item?.hora_compra}</Text>
              </Text>
            </Text>
          </Flex>
        </S.Td>

        <S.Td>
          <Flex justifyContent="center" w="full">
            <Text textAlign="center" whiteSpace="pre-line" maxW="80px">
              {item.troca_solicita ? format(new Date(item.troca_solicita), 'dd/MM/yyyy HH:mm') : ''}
            </Text>
          </Flex>
        </S.Td>

        <S.Td textAlign="center">{item.quantidade_troca}</S.Td>

        <S.Td textAlign="center">
          <Flex justifyContent="center" w="full">
            <Text whiteSpace="pre-line" textAlign="center" width="80px">
              {item.troca_compras ? format(new Date(item.troca_compras), 'dd/MM/yyyy HH:mm') : 'Sem data'}
            </Text>
          </Flex>
        </S.Td>

        <S.Td>
          <Text as="a" color="blue.500" href={item.link_layout} target="_blank">
            {item.numero_pedido}
          </Text>
        </S.Td>

        <S.Td>{item.codigo_produto}</S.Td>
        <S.Td>{item.nome_fornecedor}</S.Td>
        <S.Td>
          <Tooltip label={item.descricao_produto}>
            {firstLetterUpperCaseAndRestLowerCase(
              item.descricao_produto.length > 9 ? item.descricao_produto.substring(0, 9) + '...' : item.descricao_produto
            )}
          </Tooltip>
        </S.Td>
        <S.Td>{firstLetterUpperCaseAndRestLowerCase(item.cor)}</S.Td>
        <S.Td>
          <Tooltip label={item.impressao}>
            <Flex flexDir="column">
              <Text>{item.impressao?.length > 13 ? item.impressao.substring(0, 13) : item.impressao}</Text>
              <Text>{item.impressao?.length > 13 ? item.impressao.substring(13, 29) : ''}</Text>
            </Flex>
          </Tooltip>
        </S.Td>
        <S.Td textAlign="center">{item.quantidade_pedido}</S.Td>

        <S.Td>
          {item.trocas_solicitadas > 1 && <HistoricoTroca qtdTrocas={item.trocas_solicitadas} historico={item.historico_compra} />}

          {item.trocas_solicitadas === '1' && (
            <Text color={item.trocas_solicitadas > 1 && 'red.500'}>{item.trocas_solicitadas && item.trocas_solicitadas}x</Text>
          )}
        </S.Td>

        <S.Td textAlign="center">
          <Text whiteSpace="pre-line" width="80px">
            {item.dt_termino_prod ? format(new Date(item.dt_termino_prod), 'dd/MM/yyyy') : ''}
          </Text>
        </S.Td>

        <S.Td>{item.prazo_entrega + ' dias'}</S.Td>
      </Tr>
    )
  })

  useEffect(() => {
    getAcompanhamentoTrocas({
      dataDe: '',
      dataAte: '',
      nPedido: '',
      pendente: '',
    })
  }, [])

  const counterNumPed = data.filter((item, index, self) => self.findIndex((t) => t.numero_pedido === item.numero_pedido) === index).length

  return (
    <>
      <HeadingPages name="Acompanhamento de trocas" />

      <Flex marginBlock={'1rem'} alignItems={'center'} justifyContent={'center'}>
        <Filtro dataFilter={getAcompanhamentoTrocas} fornecedores={fornecedores} />
      </Flex>

      <Flex justifyContent="space-between" alignItems="center" marginBlock={'1rem'} mx={3}>
        <Text fontSize="1.2rem" fontWeight="bold" color="#606163">
          {counterNumPed} Pedidos
        </Text>

        <Button onClick={handleGenerateExcel} isLoading={excelLoading} leftIcon={<FaFileExcel />} size="sm" colorScheme="green" maxW="120px" w="full">
          Gerar Excel
        </Button>
      </Flex>

      <TableContainer textAlign="center" overflowY="auto" overflow="auto" h={'auto'}>
        <Table variant="striped" colorScheme="gray" fontSize="0.7rem" size={'sm'}>
          <Thead textAlign="center" px="6rem" position="sticky" top="0" zIndex="0">
            <Tr bg="#378BBF" color="white" mx="6rem">
              <S.Th>Compra</S.Th>
              <S.Th>Troca solicitada</S.Th>
              <S.Th>Qtd. troca</S.Th>
              <S.Th>Troca compras</S.Th>
              <S.Th>Ped</S.Th>

              <S.Th>Prod</S.Th>
              <S.Th>Fornecedor</S.Th>
              <S.Th>Descrição</S.Th>
              <S.Th>Cor</S.Th>
              <S.Th>Gravação</S.Th>
              <S.Th>
                Qtd <br /> Ped.
              </S.Th>

              <S.Th>
                Solicitação <br /> de <br /> Troca
              </S.Th>

              <S.Th>
                <Flex gap={2} alignItems="center">
                  Termino <br /> da <br /> prod
                  <Icon
                    as={FaArrowAltCircleDown}
                    fontSize="1.2rem"
                    color={'white'}
                    cursor="pointer"
                    transform={ordered ? 'rotate(180deg)' : ''}
                    onClick={() => handleOrderBy('dt_termino_prod')}
                    transition="0.3s"
                  />
                </Flex>
              </S.Th>
              <S.Th>
                <Flex>
                  TROCA A
                  <Icon
                    as={FaArrowAltCircleDown}
                    fontSize="1.2rem"
                    color={'white'}
                    cursor="pointer"
                    transform={orderedByTroca ? 'rotate(180deg)' : ''}
                    onClick={() => handleOrderByTrocaA('prazo_entrega')}
                    transition="0.3s"
                    ml={2}
                  />
                </Flex>
              </S.Th>
            </Tr>
          </Thead>
          <Tbody>
            {!loading ? (
              list
            ) : (
              <Tr>
                <S.Td colspan="15">
                  <Text>Carregando...</Text>
                </S.Td>
              </Tr>
            )}
          </Tbody>
        </Table>
      </TableContainer>
    </>
  )
}
